"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TextTile = require("./TextTile");
Object.keys(_TextTile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TextTile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TextTile[key];
    }
  });
});